/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React, { Suspense } from "react";
import { UIProvider } from "@/shared/ui";
import { LoadingPage } from "@pages/other/LoadingPage";
import { SupportAccessPage } from "./SupportAccessPage";

/**
 * Minimal shell for `/app/support-access`: like the OAuth callback, it is the
 * start of a session, so it cannot sit behind the auth gate.
 */
export const SupportAccessShell: React.FC = () => (
  <UIProvider>
    <Suspense fallback={<LoadingPage />}>
      <SupportAccessPage />
    </Suspense>
  </UIProvider>
);
